import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: '/adflooperationsagent',
      name: 'adflooperationsagent',
      component: () =>
        import(
          /* webpackChunkName: "adflo-operations-agent" */ './components/AdfloOperationsAgent.vue'
        ),
    },
  ],
  Module.ADFLOOPERATIONSAGENT
);
